import { useCurrencySign } from 'app/common/components-next/currency'
import toFixedValue from 'app/common/lib/toFixedValue'
import { DotsLoader } from 'app/common/templates-next/page-template'


type Props = {
  balance: number | null
  loading?: boolean
  title: string
}

const BalanceView = ({ balance, loading, title }: Props) => {
  const currency = useCurrencySign('spaceBefore')
  return (
    <span>
      {title}
      &nbsp;
      {loading ? <DotsLoader simple /> : (
        typeof balance === 'number' ? toFixedValue(balance) : 'n/a'
      )}
      {currency}
    </span>
  )
}

export default BalanceView
